import { actions } from "./state";

export const changeLokasi = (props) => {
	return {
		type: actions.CHANGE_LOKASI,
		payload: props,
	};
};

export const changeLoading = (props) => {
	return {
		type: actions.CHANGE_LOADING,
		payload: props,
	};
};
